import { useTranslation } from 'react-i18next'

import { Box } from '@enechain/ecloud-designsystem'

/**
 * 入札制限マトリクスのカード見出しに付ける「編集中」の標 (AC-BDL-006)。
 *
 * design `admin/bid-limits.html` L35 (`.bl-matrix-card.is-editing >
 * .ecl-accordion-trigger::after`)。 footer だけだと表の中を見ている間に編集中か
 * 分からないため、 カード自体でも示す。 design が指す
 * `--surface-accent-primary-low` / `--text-accent-primary-high` は tokens.css に
 * 無いので、 同じ系統の DS token (`Surface.accentPrimaryLightLow` = #ebefff /
 * `Text.accentPrimary`) を当てる。 DS `Badge` の status に accent 系が無いため
 * Box で組む。 文字は design の xs / bold ではなく、 画面内の他の badge と同じ
 * 役割 typography `badge` に揃える (fontSize と fontWeight の手書きは
 * `ebalance/no-adhoc-typography` で禁止)。
 */
export const EditingBadge = (): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Box
      as="span"
      textStyle="badge"
      marginLeft={2}
      color="Text.accentPrimary"
      background="Surface.accentPrimaryLightLow"
      borderRadius="sm"
      paddingX={2}
      paddingY="2px"
    >
      {t('page:adminBidLimits.matrix.editingBadge')}
    </Box>
  )
}
